import { useSetRecoilState } from 'recoil';
import { modalV2Atom } from '../stores/atom';
import { ModalV2Inputs } from '../types/modalV2';

export const useModalV2 = () => {
  const setModal = useSetRecoilState(modalV2Atom);

  const openModal = (inputs: ModalV2Inputs) => {
    setModal({ isOpen: true, inputs });
  };

  const closeModal = () => {
    setModal({ isOpen: false, inputs: null });
  };

  return { openModal, closeModal };
};
